/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AppsDetails } from '../models/AppsDetails';
import { DataClassesDetails } from '../models/DataClassesDetails';
import { EnvironmentDetails } from '../models/EnvironmentDetails';
import { SensitivityAnnotationsDetails } from '../models/SensitivityAnnotationsDetails';

/**
* Resource classification details.
*/
export class Classifications {
  'dataClassesDetails'?: DataClassesDetails;
  'environmentDetails'?: EnvironmentDetails;
  'appsDetails'?: AppsDetails;
  'sensitivityAnnotationsDetails'?: SensitivityAnnotationsDetails;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "dataClassesDetails",
      "baseName": "dataClassesDetails",
      "type": "DataClassesDetails",
      "format": ""
    },
    {
      "name": "environmentDetails",
      "baseName": "environmentDetails",
      "type": "EnvironmentDetails",
      "format": ""
    },
    {
      "name": "appsDetails",
      "baseName": "appsDetails",
      "type": "AppsDetails",
      "format": ""
    },
    {
      "name": "sensitivityAnnotationsDetails",
      "baseName": "sensitivityAnnotationsDetails",
      "type": "SensitivityAnnotationsDetails",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return Classifications.attributeTypeMap;
  }

  public constructor() {
  }
}

